<template>
  <MultiSelectDefault
    :facet="facet"
    :update-selected="onUpdate"
    :is-dynamic="isDynamic"
    :custom-value-renderer="customValueRenderer"
  >
    <Form
      ref="customForm"
      @submit="onSubmit"
    >
      <p class="heavy margin-top-m margin-bottom-s">
        Custom Range
      </p>
      <div class="grid-x align-top custom-range">
        <div class="cell range-input">
          <InputText
            ref="minInput"
            v-model="customRange.minVal"
            type="number"
            name="min"
            label="Min"
          />
        </div>
        <div class="cell range-text shrink padding-top-xs">
          to
        </div>
        <div class="cell range-input margin-right-xs">
          <InputText
            ref="maxInput"
            v-model="customRange.maxVal"
            class="cell"
            type="number"
            name="max"
            label="Max"
            :hide-error-message="true"
          />
        </div>
        <div class="cell range-button">
          <button
            class="secondary button"
            type="submit"
          >
            Go
          </button>
        </div>
      </div>
    </Form>
  </MultiSelectDefault>
</template>

<script setup>
import Form from '@atomic-ui/form';
import InputText from '@atomic-ui/inputText';
import useMultiSelectRange from '../../composables/useMultiSelectRange';
import MultiSelectDefault from './MultiSelectDefault';

const props = defineProps({
  facet: {
    type: Object,
    required: true,
  },
  isDynamic: {
    type: Boolean,
    default: () => false,
  },
});

const {
  onSubmit,
  customRange,
  customForm,
  minInput,
  maxInput,
  onUpdate,
  customValueRenderer,
} = useMultiSelectRange(props);
</script>

<style scoped lang="scss">
:deep(.input-container) {
  margin-top: 0;
  margin-bottom: 0;
}

.custom-range {
  width: rem-calc(264);
  flex-flow: row;
  :deep(.form-error) {
    &.is-visible {
      display: inline-flex !important;
      margin: rem-calc(8 0 0 0);
      white-space: nowrap;
    }
  }
}

.range-text {
  color: $gray-1-color;
  margin: 0 rem-calc(12);
}
.range-input {
  width: rem-calc(80);
}
.range-button {
  width: rem-calc(60);
}
</style>
